import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/coupon/gsq25_detail.jpg'


const _withScopeId = n => (_pushScopeId("data-v-6755ae4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col pageDetail" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img class=\"detailTop\" src=\"" + _imports_0 + "\" data-v-6755ae4c><div class=\"content\" data-v-6755ae4c><div class=\"detailTitle\" data-v-6755ae4c>购书优惠券</div><div class=\"detailType\" data-v-6755ae4c>领取时间</div><div class=\"detailContent\" data-v-6755ae4c> 6月28日—7月2日。 </div><div class=\"detailType\" data-v-6755ae4c>使用时间</div><div class=\"detailContent\" data-v-6755ae4c> 7月3日—7月7日。 </div><div class=\"detailType\" data-v-6755ae4c>领取及使用规则</div><div class=\"detailContent\" data-v-6755ae4c><span data-v-6755ae4c>通过“我的丹阳”app，于6月28日—7月2日向市民推出3万元购书优惠券，优惠券面值15元，共2000张，分5天投放，每天投放400张。书展期间，书店推出购书折扣，并可同步使用镇江、丹阳购书券抵扣现金。</span></div></div>", 2)
const _hoisted_4 = { class: "fixBtn" }
const _hoisted_5 = { class: "btn_time" }
const _hoisted_6 = {
  key: 0,
  class: "btn btn_gray"
}
const _hoisted_7 = {
  key: 1,
  class: "btn btn_ready"
}
const _hoisted_8 = {
  key: 3,
  class: "btn btn_gray"
}
const _hoisted_9 = {
  key: 4,
  class: "btn btn_gray"
}
const _hoisted_10 = {
  key: 5,
  class: "btn btn_gray"
}
const _hoisted_11 = {
  key: 6,
  class: "btn btn_gray"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.detailDatas.startTimeInstruction), 1),
      (_ctx.detailDatas.dhStatus == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : (_ctx.detailDatas.dhStatus == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "即将开始"))
          : (_ctx.detailDatas.dhStatus == 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "btn btn_red",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getCouponKill && _ctx.getCouponKill(...args)))
              }, " 抢券中 "))
            : (_ctx.detailDatas.dhStatus == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 已抢完 "))
              : (_ctx.detailDatas.dhStatus == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 只可抢一张 "))
                : (_ctx.detailDatas.dhStatus == 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 活动已结束 "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, "不可重复抢券"))
    ])
  ]))
}